import React from "react";
import { Link } from "react-router-dom";

export const BottomTextAndLink = ({
  textCss,
  text,
  link,
  linkText,
  linkTextColor,
  forcedStyles,
}) => {
  return (
    <React.Fragment>
      <p className={textCss} style={forcedStyles} style={{color:'#9E9E9E'}}>
        {text}{" "}
        <Link
          to={link}
          className={
            linkTextColor === true
              ? "reusableButton-simple-red"
              : "reusableButton-simple-light"
          }
        >
          {linkText}
        </Link>
      </p>
    </React.Fragment>
  );
};

export const BottomTextAndButton = ({ textCss, onClick, text, linkText }) => {
  return (
    <React.Fragment>
      <p className={textCss}>
        {text}{" "}
        <button
          type="button"
          className="reusableButton-simple-blue"
          onClick={onClick}
        >
          {linkText}
        </button>
      </p>
    </React.Fragment>
  );
};
